export default __webpack_public_path__ + "static/media/00.7619d3e1.jpg";